// src/components/Hero.js
import React from 'react';
import { Link } from 'react-router-dom';
import './Hero.css';

function Hero() {
  return (
    <section className="hero" id="home">
      {/* Existing Hero Content */}
      <div className="hero-content">
        <div className="text-content">
          <p className="hero-subtitle">#1 on consultancy</p>
          <h1>Your One-Stop Consultancy Expert</h1>
          <p className="hero-description">
            Unlock success with Left Right Solutions - your premier partner for global solutions and innovative services.
          </p>
          <Link to="/contact"><a href="#contact" className="cta-button">Contact Us today</a></Link>
        </div>
        <div className="hero-image">
          <img src="hero.jpg" alt="Consultancy Meeting" />
        </div>
      </div>

      {/* New Recognition Section */}
      <div className="recognition-section">
        <div className="recognition-content">
          <h2 className="recognition-title">The #1 consultancy for modern business needs.</h2>
          <p className="recognition-subtitle">As recognized by global consultancies and industry leaders</p>
          <div className="recognition-logos">
            <img src="ss.png" alt="Logo 1" />
            <img src="sss.jpeg" alt="Logo 2" />
            <img src="h.jpg" alt="Logo 3" />
            <img src="ca.jpg" alt="Logo 4" />
            <img src="co.jpeg" alt="Logo 5" />
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;
